
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import openbg from '@/assets/nvzhigongquanyi/ball.png'
import { getExam, save, getview } from '@/api/jfhl.js'
import { numToWord } from '@/libs/utils.js'
import config from '@/config/index'
export default {
directives: {
TransferDom
},
components: {
XDialog
},
data() {
return {
baseUrl: config.baseUrl,
openbg: openbg,
lotid: 0,
examList: {},
subjectid: [],
useroption: [],
multi: [],
partyid: this.$route.params.partyid,
paperInfoid: '',
active: 0, // 当前题数
errorList: [],
dialogText: '',
dialogType: '',
btnPre: '上一题',
btnNext: '下一题',
ispre: true,
isnext: true,
showDialog: false,
showErrorList: false,
showAddress: false,
partyuserid: this.$route.params.partyuserid,
score: 0,
btnText: '',
answerList: []
}
},
computed: {
accountid() {
return this.$store.state.user.accountid
},
userid() {
return this.$store.state.user.userid
}
},
mounted() {
this.answerMap = new Map()
this.view()
},
watch: {
active(newValue, oldValue) {
if (newValue === this.examList.length - 1) {
this.btnNext = '提交'
} else {
this.btnNext = '下一题'
}
},
multi(newValue, oldValue) {}
},
methods: {
numToWord(num) {
return numToWord(num)
},

view() {
getview({
id: this.partyid
}).then(res => {
this.paperInfoid = res.obj.paperid
this.lotid = res.obj.lotid
this.getExam()
})
},
getExam() {
getExam({
paperInfoid: this.paperInfoid,
openid: this.accountid
}).then(data => {
if (data.obj.ANSWERNUM <= 0) {
this.$vux.toast.text('您今天的三次答题机会已用完请明天再来')
setTimeout(() => {
this.$router.push({
name: 'nvzhigongquanyiIndex',
params: { partyid: this.partyid }
})
}, 1000)
return false
}
this.examList = data.obj.SUBJECTLIST
data.obj.SUBJECTLIST.forEach(element => {
this.subjectid.push(element.SUBJECTID)
})
})
},

btnClick() {
this.showDialog = false
if (this.errorList.length > 0) {
this.showErrorList = true
} else {
this.$router.push({
name: 'nvzhigongquanyiIndex',
params: { partyid: this.partyid }
})
}
},

answerNext() {
if (this.active + 1 >= this.examList.length) {
if (this.examList[this.active].TYPE === 2) {
if (this.multi.length === 0) {
this.$vux.toast.text('请选择答案')
return false
}

let isExist = false
this.answerList.forEach(item => {
if (item.subjectid === this.subjectid[this.active]) {
item.useroption = this.multi.join(',')
isExist = true
}
})
if (!isExist) {
this.answerList.push({
subjectid: this.subjectid[this.active],
useroption: this.multi.join(',')
})
}
this.multi = []
}
let subjectids = []
let useroptions = []
this.answerList.forEach(item => {
subjectids.push(item.subjectid)
useroptions.push(item.useroption)
})
save({
paperInfoid: this.paperInfoid,
subjectid: subjectids.join(';'),
useroption: useroptions.join(';'),
openid: this.accountid,
partyuserid: this.partyuserid
}).then(data => {
this.showDialog = true
this.errorList = data.obj.ERRORLIST || []
this.btnText = this.errorList.length > 0 ? '查看错题' : '回到首页'
let wt = this.errorList.length
this.score = data.obj.mark
this.dialogText =
'答对' + (this.examList.length - wt) + '题，答错' + wt + '题'
})
} else {
if (this.examList[this.active].TYPE === 1) {
if (!this.useroption[this.active]) {
this.$vux.toast.text('请选择答案')
return false
}

let isExist = false
this.answerList.forEach(item => {
if (item.subjectid === this.subjectid[this.active]) {
item.useroption = this.useroption[this.active]
isExist = true
}
})
if (!isExist) {
this.answerList.push({
subjectid: this.subjectid[this.active],
useroption: this.useroption[this.active]
})
}
} else if (this.examList[this.active].TYPE === 2) {
if (this.multi.length === 0) {
this.$vux.toast.text('请选择答案')
return false
}

let isExist = false
this.answerList.forEach(item => {
if (item.subjectid === this.subjectid[this.active]) {
item.useroption = this.multi.join(',')
isExist = true
}
})
if (!isExist) {
this.answerList.push({
subjectid: this.subjectid[this.active],
useroption: this.multi.join(',')
})
}
this.multi = []
}
this.active++

if (this.examList[this.active].TYPE === 2) {
this.answerList.forEach(item => {
if (item.subjectid === this.subjectid[this.active]) {
if (item.useroption.length > 0) {
this.multi = item.useroption.split(',')
}
}
})
}
}
},
answerPre() {

if (this.examList[this.active].TYPE === 2) {

let isExist = false
this.answerList.forEach(item => {
if (item.subjectid === this.subjectid[this.active]) {
item.useroption = this.multi.length > 0 ? this.multi.join(',') : []
isExist = true
}
})
if (!isExist) {
this.answerList.push({
subjectid: this.subjectid[this.active],
useroption: this.multi.length > 0 ? this.multi.join(',') : []
})
}
this.multi = []
}
this.active--

if (this.examList[this.active].TYPE === 2) {
this.answerList.forEach(item => {
if (item.subjectid === this.subjectid[this.active]) {
if (item.useroption.length > 0) {
this.multi = item.useroption.split(',')
}
}
})
}
},
gorule() {
this.$router.push({
name: 'nvzhigongquanyiRule',
params: { partyid: this.partyid }
})
},
goWrong() {
this.showErrorList = false
this.$router.push({
name: 'nvzhigongquanyiIndex',
params: { partyid: this.partyid }
})
},
reload() {
this.$router.go(-1)
}
}
}
